import axios from "axios";
import store from "@/store";
import router from "../routes/router";
import NProgress from "nprogress";

const HTTP_UNAUTHORISED = 401;

const config = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
  timeout: 1000 * 30 // 30 seconds timeout
};

const apiClient = axios.create(config);

// before a request is made start the nprogress
apiClient.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

apiClient.interceptors.response.use(
  function(response) {
    NProgress.done();
    return response;
  },
  function(error) {
    NProgress.done();
    // console.log("axios error", error);
    store.dispatch("setIsLoading", false, { root: true });
    if (error.response && error.response.status === HTTP_UNAUTHORISED) {
      store.dispatch("user/logout");
      router.go({
        path: "/login",
        force: true
      });
    }
    return Promise.reject(error);
  }
);

export { apiClient };
